// Batch 32 · B32-1 — the figures-layer line: one full sentence with the reason, under the page title of the 9 screens that show
// ledger figures (replaces the LayerBadge pill). English as the owner wrote it in the card; Arabic exactly as given in
// "AZEX Batch 32 Items V18" (a native Arabic reader checks before release). Merged into lib/i18n.js (big-file rule).
export const I18N_B32_LAYER = {
  en: {
    layerLine: {
      scoping: "Unadjusted figures from client data, as scoping is planning work and is meant to run on the client's own ledger.",
      analytics: "Unadjusted figures from client data, as analytics is planning and testing work and is meant to run on the client's own ledger.",
      sampling: "Unadjusted figures from client data, as sampling is testing work and is meant to run on the client's own ledger.",
      jeTesting: "Unadjusted figures from client data, as journal entry testing is testing work and is meant to run on the client's own ledger.",
      glImport: "Unadjusted figures from client data, as this is the client's ledger exactly as uploaded.",
      openingBalances: "Unadjusted figures from client data, as opening balances are checked against the client's own ledger.",
      ifrs: "Including audit adjustments, as the financial statements are the client's ledger plus the posted audit adjustments.",
      ratios: "Including audit adjustments, as the ratios are calculated on the client's ledger plus the posted audit adjustments.",
      adjustingEntries: "Including audit adjustments, as this screen shows the client's ledger and the effect of each posted audit adjustment.",
    },
  },
  ar: {
    layerLine: {
      scoping: "أرقام غير معدّلة من بيانات العميل، لأن تحديد النطاق عمل تخطيطي يُجرى على دفاتر العميل كما هي.",
      analytics: "أرقام غير معدّلة من بيانات العميل، لأن الإجراءات التحليلية عمل تخطيطي واختباري يُجرى على دفاتر العميل كما هي.",
      sampling: "أرقام غير معدّلة من بيانات العميل، لأن اختيار العينات عمل اختباري يُجرى على دفاتر العميل كما هي.",
      jeTesting: "أرقام غير معدّلة من بيانات العميل، لأن اختبار قيود اليومية عمل اختباري يُجرى على دفاتر العميل كما هي.",
      glImport: "أرقام غير معدّلة من بيانات العميل، لأن هذا هو دفتر الأستاذ كما رفعه العميل.",
      openingBalances: "أرقام غير معدّلة من بيانات العميل، لأن الأرصدة الافتتاحية تُطابَق مع دفاتر العميل كما هي.",
      ifrs: "شاملة تسويات المراجعة، لأن القوائم المالية هي دفاتر العميل مضافاً إليها تسويات المراجعة المرحّلة.",
      ratios: "شاملة تسويات المراجعة، لأن النسب تُحسب على دفاتر العميل مضافاً إليها تسويات المراجعة المرحّلة.",
      adjustingEntries: "شاملة تسويات المراجعة، لأن هذه الشاشة تعرض دفاتر العميل وأثر كل تسوية مراجعة مرحّلة.",
    },
  },
};

// screen → layer it reads ("client" = the client's ledger as uploaded; "adjusted" = the ledger + the posted audit adjustments)
export const LAYER_OF_SCREEN = {
  scoping: "client", analytics: "client", sampling: "client", jeTesting: "client", glImport: "client", openingBalances: "client",
  ifrs: "adjusted", ratios: "adjusted", adjustingEntries: "adjusted",
};

export default I18N_B32_LAYER;
